import { LoginOutlined, UserOutlined } from "@ant-design/icons"
import { Button, Dropdown, Menu } from "antd"
import { useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import GeneralContext from "../../context/GeneralContext/GeneralContext"
import { displayMessage } from "../../helpers/messages"
import styles from "../../services/styles"
import menus, { sideMenuItensIconsStyle, topMenuItensIconsStyle } from "./Menus"

const { COLORS } = styles

export default function ProfileOptions() {
  const {
    setLoggedUser, loggedUser
  } = useContext(GeneralContext)
  
  const handleOnClickLogout = () => {
    setLoggedUser(null)
  }

  const items = [
    ...menus.topMenuItens.map(item => ({ key: item.key, label: <Link to={item.key} style={{ color: COLORS.GREEN[900] }}>{item.title}</Link> })),
    { key: '/logout', label: <div onClick={handleOnClickLogout} style={{ color: COLORS.GREEN[900] }}>{displayMessage('LOGOUT')}</div> }
  ]

  return (
    <div style={{ color: COLORS.GREEN[900], fontSize: 17, fontWeight: "bold", marginRight: 15, lineHeight: 37, display: 'flex', alignItems: 'center' }}>
      <Dropdown
        menu={{ items }}
        placement="bottomLeft"
        size="large"
      >
        <Button
          icon={<UserOutlined style={{ fontSize: 20, color: COLORS.GREEN[900] }} />}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 40, fontSize: 15, color: COLORS.GREEN[900] }}
        >
          {loggedUser?.full_name}
        </Button>
      </Dropdown>
    </div>
  )
}